import { Map } from 'immutable';
import actions from '../../constants/admin/mailing';

const defaultState = () => new Map({
  mailsList: undefined,
  mailDetail: undefined,
  mailUsers: undefined,
  mailItem: new Map(),
  mailJournal: undefined,
  mailSubmitError: false,
  mailSubmitting: false,
  mailsAreLoading: false,
  mailComment: "",
  responsibleStaff: undefined,
  submitAllStaff: true,
  userAnswer: undefined,
  operatorMails: undefined,
  sendMailOperatorFail: false,
  sendMailOperatorSuccess: false,
  sendMailOperatorSubmitting: false,

  attachedFile: undefined
})

export default (state = defaultState(), action) => {
  switch (action.type) {
    case actions.LOAD_MAILS:
      return state.set('mailsList', action.data);
    case actions.LOAD_MAIL_DETAIL:
      return state.set('mailDetail', action.data);
    case actions.LOAD_MAIL_USERS:
      return state.set('mailUsers', action.data);
    case actions.SET_MAIL_ITEM:
      return state.set('mailItem', action.data);
    case actions.SET_MAIL_ITEM_VALUE:
      return state.setIn(['mailItem', action.key], action.data);
    case actions.LOAD_MAIL_JOURNAL:
      return state.set('mailJournal', action.data);
    case actions.SET_MAIL_ERROR:
      return state.set('mailSubmitError', action.data);
    case actions.SET_MAIL_IS_LOADING:
      return state.set('mailSubmitting', action.data);
    case actions.MAILS_ARE_LOADING:
      return state.set('mailsAreLoading', action.data);
    case actions.CHANGE_MAIL_COMMENT:
      return state.set('mailComment', action.data);
    case actions.SEND_MAIL_USER_OPERATOR_FAIL:
      return state.set('sendMailOperatorFail', action.data);
    case actions.SEND_MAIL_USER_OPERATOR_SUCCESS:
      return state.set('sendMailOperatorSuccess', action.data)
    case actions.LOAD_RESPONSIBLE_STAFF:
      return state.set('responsibleStaff', action.data);
    case actions.CHANGE_RESPONSIBLE_STAFF:
      return state.setIn(['responsibleStaff', action.key, "checked"], action.data);
    case actions.SUBMIT_ALL_STAFF:
      return state.set('submitAllStaff', action.data);
    case actions.CHANGE_STAFF_ALL:
      return state.set('responsibleStaff', action.data);
    case actions.LOAD_USER_ANSWER:
      return state.set('userAnswer', action.data);
    case actions.LOAD_OPERATOR_MAILS:
      return state.set('operatorMails', action.data);
    case actions.CLEAN_MAIL_STORE:
      const newState = new Map({
        'mailItem': new Map(),
        'mailComment': '',
        'attachedFile': undefined,
        'mailSubmitError': false,
        'sendMailOperatorFail': false
      })
      return state.merge(newState);
    case actions.SEND_MAIL_USER_OPERATOR_SUBMITTING:
      return state.set('sendMailOperatorSubmitting', action.data)

    case actions.ATTACH_FILE:
      return state.set('attachedFile', action.data);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/admin/mailing.js